import React from 'react';

const DatepickerInput = ({ ...props }) => (
  <input data-testid='act-datepicker--input' data-testid-e2e='act-datepicker--input' type='text' {...props} readOnly />
);

export default DatepickerInput;
